import React, { PropTypes, Component } from 'react'
// components
import { RowIndicators } from './RowIndicators.jsx'
import { RowSummaryIndicators } from './RowSummaryIndicators.jsx'
// css
import style from './PanelIndicators.css'
import HeaderFiltro from '../HeaderFiltro.jsx'

export class PanelIndicators extends Component {
    constructor(props) {
        super(props)
        this.state = {
            indicadores: [],
            sinIndicadores: false,
        }
        this.actualizarAvances = this.actualizarAvances.bind(this);
        this.handleActualizarClick = this.handleActualizarClick.bind(this);
    }

    actualizarAvances() {
        this.props.getStats()
    }

    handleActualizarClick() {
        this.actualizarAvances();
    }

    actualizarFiltro(filtros) {
        const arrayFinal = []
        const filtrados = filtros.filter(aux =>
            aux.seleccionado == true)
        if (filtrados.length == 0) {
            this.setState({
                indicadores: arrayFinal,
                sinIndicadores: true,
            })
            this.props.setFiltro(arrayFinal)
        } else {
            for (let i = 0; i < this.props.indicators.length; i++) {
                for (let j = 0; j < filtrados.length; j++) {
                    if (this.props.indicators[i].client_name == filtrados[j].texto) {
                        arrayFinal.push(this.props.indicators[i])
                    }
                }
            }
            this.setState({
                indicadores: arrayFinal,
                sinIndicadores: false,
            })
            if (filtros.length == filtrados.length) {
                this.props.setFiltro(arrayFinal, true)
            } else {
                this.props.setFiltro(arrayFinal)
            }
        }
    }
    componentDidMount() {
        this.props.fetchIndicators()
        // Espera 30 segundos antes de ejecutar por primera vez
        this.timeout = setTimeout(() => {
            this.actualizarAvances();
            // Luego se repite cada 30 segundos
            this.interval = setInterval(() => {
                this.actualizarAvances();
            }, 300000);
        }, 15000);
    }
    componentWillUnmount() {
        clearTimeout(this.timeout);
        clearInterval(this.interval);
    }
    render() {
        return (
            <div className="panel panel-primary" style={{ maxHeight: 'calc(95vh - 100px)', overflowY: 'auto' }}>
                <div className="panel-heading">Indicadores de Gestión Inventarios, {this.props.dateDay} {this.props.dateTitle}
                    <span className="pull-right glyphicon glyphicon glyphicon glyphicon glyphicon-chevron-right" onClick={this.props.dayBefore} />
                    <span className="pull-right glyphicon glyphicon glyphicon glyphicon glyphicon-chevron-left" onClick={this.props.dayAfter} />
                    <input className={style.inputDate} type="date" value={new Date(this.props.day).toISOString().slice(0, 10)} onChange={this.props.selectDay} />
                    <button
                        className="btn btn-sm btn-primary pull-right"
                        onClick={this.handleActualizarClick}
                        style={{ marginRight: '10px' }}
                    >
                        Actualizar Avance 
                        <span style={{padding: '2px'}} className='glyphicon glyphicon-signal'></span>
                    </button>
                </div>
                <div className={`panel-body ${style.PanelIndicators_panelBody}`}>
                    <div>
                        <table className={`table table-striped table-hover no-margin table-condensed ${style.PanelIndicators}`}>
                            <thead style={{ position: 'sticky', top: '0px', zIndex: '1', backgroundColor: 'white' }}>
                                <tr>
                                    {this.props.perms.backups ? <th>Backups</th> : null}
                                    <th colSpan={this.props.permissions ? 2 : 1}>Reporte</th>
                                    {/* {this.props.admin == true ? null : */<th> 
                                        <HeaderFiltro nombre='Cliente'
                                            indicators={this.props.indicators}
                                            actualizarFiltro={this.actualizarFiltro.bind(this)}
                                            sinFiltro={this.props.sinFiltro}
                                        />
                                    </th>}
                                    <th>CE</th>
                                    <th className={style.PanelIndicators_thStoreName}>Nombre</th>
                                    <th className={style.PanelIndicators_thSupervisorName}>Supervisor</th>
                                    <th className={style.PanelIndicators_thItemsQuantity}>Dotación</th>
                                    <th className={style.PanelIndicators_thItemsQuantity}>Conteo Unidades</th>
                                    {this.props.desvio ? <th className={style.PanelIndicators_thItemsQuantity}>Desv. Stock</th> : null}
                                    <th className={style.PanelIndicators_thTime}>Horas IG</th>
                                    {/* {this.props.permissions ? <th className={style.PanelIndicators_thTime}>Hora Térm.</th> : null} */}
                                    {this.props.permissions ? <th>Nota Conteo</th> : null}
                                    {this.props.permissions ? <th>Nota Pres.</th> : null}
                                    {this.props.permissions ? <th>Nota Super.</th> : null}
                                    <th>Nota Promedio</th>
                                    <th style={{minWidth: '50px'}}>Error SEI %</th>
                                    <th>Estand. SEI %</th>
                                    {this.props.showOtherData ?
                                        <th style={{whiteSpace: 'nowrap'}}>Varianza %</th> : null
                                    }
                                    <th className={style.PanelIndicators_thPttRevRate}>Tiempo Revisión</th>
                                    <th className={style.PanelIndicators_thPttRevRate}>% Rev. Patentes</th>
                                    <th className={style.PanelIndicators_thItemsRevRate}>% Rev. Items</th>
                                    <th className={style.PanelIndicators_thQfErrorRate} style={{minWidth: '45px'}}>Error JL %</th>
                                    <th className={style.PanelIndicators_thClientStandardRate} style={{minWidth: '60px'}}>Estand. Cliente %</th>
                                    <th className={style.PanelIndicators_thDiffCLP}>Dif. Neta MM $</th>
                                    {this.props.permissions ? <th className={style.PanelIndicators_thButtonDownload}>Acta</th> : null}
                                    <th className={style.PanelIndicators_thButtonDownload}>{this.props.permissions ? "Acta PDF" : "Acta"}</th>
                                    <th className={style.PanelIndicators_thButtonDownload}>Checklist</th>
                                    <th className={style.PanelIndicators_thButtonDownload}>IMG</th>
                                    <th className={style.PanelIndicators_thButtonDownload}>Zip</th>
                                    <th className={style.PanelIndicators_thButtonPUC}></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.cargandoData == true ? <tr><td colSpan="23" className="text-center">Cargando...</td></tr> : this.props.indicators.length === 0 ?
                                    <tr><td colSpan="23" className="text-center">Sin indicadores</td></tr> :
                                    ((this.props.sinFiltro) || (this.state.indicadores.length == 0 && !this.state.sinIndicadores) || this.state.indicadores.length == this.props.indicators.length ?
                                        this.props.indicators.map((indicator, index) => {
                                            return (
                                                <RowIndicators
                                                    key={indicator.inv}
                                                    indicator={indicator}
                                                    showOtherData={this.props.showOtherData}
                                                    permissions={this.props.permissions}
                                                    perms={this.props.perms}
                                                    fcv={this.props.fcv}
                                                    unDesviadas={this.props.desvio}
                                                    reportar={this.props.reportar}
                                                    date={this.state.date}
                                                    comentarioDashboard={this.props.comentarioDashboard}
                                                    openModalActa={this.props.openModalActa}
                                                    openModalActaCliente={this.props.openModalActaCliente}
                                                    openModalImagenes={this.props.openModalImagenes}
                                                    openModalChecklist={this.props.openModalChecklist}
                                                    admin={this.props.admin}
                                                />
                                            )
                                        }) :
                                        (this.state.sinIndicadores ?
                                            <tr><td colSpan="23" className="text-center">Sin indicadores</td></tr> :
                                            this.state.indicadores.map((indicator, index) => {
                                                return (
                                                    <RowIndicators
                                                        key={indicator.inv}
                                                        indicator={indicator}
                                                        showOtherData={this.props.showOtherData}
                                                        permissions={this.props.permissions}
                                                        perms={this.props.perms}
                                                        fcv={this.props.fcv}
                                                        unDesviadas={this.props.desvio}
                                                        reportar={this.props.reportar}
                                                        date={this.state.date}
                                                        comentarioDashboard={this.props.comentarioDashboard}
                                                        openModalActa={this.props.openModalActa}
                                                        openModalActaCliente={this.props.openModalActaCliente}
                                                        openModalImagenes={this.props.openModalImagenes}
                                                        openModalChecklist={this.props.openModalChecklist}
                                                        admin={this.props.admin}
                                                    />
                                                )
                                            })))}
                            </tbody>
                            <tfoot style={{ backgroundColor: 'white' }}>
                                <RowSummaryIndicators
                                    summaryIndicators={this.props.summaryIndicatorsRange}
                                    title="Resumen Turno"
                                    linkDownloadData={`/inventarios/descargar-consolidado?client=${this.props.idClient}&fechaInicio=${this.props.dateInit}&fechaFin=${this.props.dateInit}&orden=desc`}
                                    showOtherData={this.props.showOtherData}
                                    permissions={this.props.permissions}
                                    fcv={this.props.fcv}
                                    fsb={this.props.perms.permFSB}
                                    unDesviadas={this.props.desvio}
                                    reportar={this.props.reportar}
                                    admin={this.props.admin}
                                />
                                <RowSummaryIndicators
                                    summaryIndicators={this.props.summaryIndicatorsMonth}
                                    title="Resumen Mes Actual"
                                    linkDownloadData={`/inventarios/descargar-consolidado?client=${this.props.idClient}&mes=${this.props.dateInit}&orden=desc`}
                                    showOtherData={this.props.showOtherData}
                                    permissions={this.props.permissions}
                                    fcv={this.props.fcv}
                                    fsb={this.props.perms.permFSB}
                                    unDesviadas={this.props.desvio}
                                    reportar={this.props.reportar}
                                    admin={this.props.admin}
                                    cargando={this.props.cargandoMes}
                                />
                                <RowSummaryIndicators
                                    summaryIndicators={this.props.summaryIndicatorsYear}
                                    title="Resumen Año Actual"
                                    linkDownloadData={`/inventarios/descargar-consolidado?client=${this.props.idClient}&mes=${this.props.dateYear}&orden=desc`}
                                    showOtherData={this.props.showOtherData}
                                    permissions={this.props.permissions}
                                    fcv={this.props.fcv}
                                    fsb={this.props.perms.permFSB}
                                    unDesviadas={this.props.desvio}
                                    reportar={this.props.reportar}
                                    admin={this.props.admin}
                                    cargando={this.props.cargandoYear}
                                />
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}
PanelIndicators.propTypes = {
    indicators: PropTypes.array.isRequired
}


// WEBPACK FOOTER //
// ./frontEnd/home/components/managementIndicators/PanelIndicators.jsx